








































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyForm from "@/mixins/form";

// @ts-ignore
import JsonViewer from "vue-json-viewer";

Vue.use(JsonViewer);

@Component
export default class extends Mixins(MyForm) {
  data: any[] = [];

  loading = false;

  columns: any[] = [
    { title: "字段名", dataIndex: "fieldname" },
    { title: "旧值", scopedSlots: { customRender: "oldval" } },
    { title: "新值", scopedSlots: { customRender: "newval" } }
  ];

  async mounted() {
    this.loading = true;
    const res = await this.$store.dispatch("operationlogs/detail", {
      id: this.editId
    });

    if (res && res.Data) {
      this.formData = res.Data;
      //   this.data = res.Data.fields
    }

    this.loading = false;
  }

  renderJsonValue(str: string) {
    try {
      return JSON.parse(str);
    } catch (e) {
      // console.log(e);
      return str;
    }
  }
}
